import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Coverage } from '../../../models/quotation-model/catalogs/coverage.model';
import { BaseInterface } from '../../../models/quotation-model/catalogs/base.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoverageService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getCoverages(brandId: number, insuranceId: number): Observable<Coverage[]> {
    return this.http.get<Coverage[]>(
      this.URL_API + '/Coverage?brandId=' + brandId + '&insuranceId=' + insuranceId,
    );
  }
}
